import { styled } from '@mui/material/styles'
import { MODAL_DRAWER_HEADER_HT } from '../../constants'
const PREFIX = 'ModalDrawer'
const SIDE_DRAWER_WIDTH = 320

export const classes = {
  clearButton: `${PREFIX}-clearButton`,
  drawerContent: `${PREFIX}-drawerContent`,
  sideDrawer: `${PREFIX}-sideDrawer`,
  drawer: `${PREFIX}-drawer`,
  topDrawer: `${PREFIX}-topDrawer`,
  header: `${PREFIX}-header`,
}

const Root = styled('div')({
  [`& .${classes.clearButton}`]: {
    width: 60,
  },

  [`& .${classes.drawerContent}`]: {
    justifyContent: 'flex-end',
    userSelect: 'none',
    '& div': {
      userSelect: 'none',
    },
    '& p': {
      userSelect: 'none',
    },
  },

  [`& .${classes.sideDrawer}`]: {
    width: SIDE_DRAWER_WIDTH,
    height: '100%',
    position: 'absolute',
    backgroundColor: 'white',
    top: 0,
    right: -SIDE_DRAWER_WIDTH,
    zIndex: 1000,
    willChange: 'right',
    overflowY: 'auto',
  },

  [`& .${classes.drawer}`]: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    backgroundColor: 'white',
    top: '100%',
    left: 0,
    zIndex: 1,
    willChange: 'top',
  },

  [`& .${classes.topDrawer}`]: {
    top: '-100%',
  },

  [`& .${classes.header}`]: {
    height: MODAL_DRAWER_HEADER_HT,
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    userSelect: 'none',
    '& div': {
      userSelect: 'none',
    },
  },
})

export default Root
export { MODAL_DRAWER_HEADER_HT, SIDE_DRAWER_WIDTH }
